export const isFileTypeImage = contentType => {
  switch (contentType) {
    case "image/jpeg":
    case "image/png":
    case "image/bmp":
      return true;
    default:
      return false;
  }
};
export const getSecurePasswordString = () => {
  return "Password must be 12 chars long, include 1 special character, 1 number and 1 upper case character";
};
export const getManagerProfileStorageKey = () => {
  return "limitless-mp";
};